module.exports = __webpack_public_path__ + "static/media/devops.34f27fa7.svg";